import { LatLng } from "leaflet";
import { useState } from "react";
import { Polyline, useMapEvents } from "react-leaflet";

interface LineDrawProps {
  onDraw: (geometry: LatLng[]) => void;
}

const LineDrawTool = ({ onDraw }: LineDrawProps) => {
  const [start, setStart] = useState<LatLng>();
  const [end, setEnd] = useState<LatLng>();

  useMapEvents({
    click(e) {
      if (start && end) {
        onDraw([start, end]);
        setStart(undefined);
        setEnd(undefined);
        return;
      }

      setStart(e.latlng);
    },
    mousemove(e) {
      if (start) {
        setEnd(e.latlng);
      }
    },
  });

  return start !== undefined && end !== undefined ? <Polyline positions={[start, end]} /> : null;
};

export default LineDrawTool;
